import { useTranslation } from 'react-i18next';

import { useState } from 'react';

import { Anchor, Button, Checkbox, Modal, Stack, Text, TextInput, Title } from '@optiro/ui';

import { useEnterTrial } from '@/hooks/useEnterTrial/useEnterTrial';

interface EnterTrialGateProps {
  opened: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export function EnterTrialGate({ opened, onClose, onSuccess }: EnterTrialGateProps) {
  const { t } = useTranslation('billing');
  const enterTrial = useEnterTrial();

  const [name, setName] = useState('');
  const [title, setTitle] = useState('');
  const [dpaAccepted, setDpaAccepted] = useState(false);
  const [subscriptionTermsAccepted, setSubscriptionTermsAccepted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    enterTrial.mutate(
      {
        name,
        title,
        dpa_accepted: dpaAccepted,
        subscription_terms_accepted: subscriptionTermsAccepted,
      },
      { onSuccess }
    );
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Title order={3}>{t('enterTrialGate.title')}</Title>}
      centered
    >
      <form onSubmit={handleSubmit}>
        <Stack gap="md">
          <Text size="sm" c="dimmed">
            {t('enterTrialGate.description')}
          </Text>

          <TextInput
            label={t('enterTrialGate.nameLabel')}
            required
            autoFocus
            value={name}
            onChange={(e) => setName(e.currentTarget.value)}
          />
          <TextInput
            label={t('enterTrialGate.titleLabel')}
            required
            value={title}
            onChange={(e) => setTitle(e.currentTarget.value)}
          />

          <Checkbox
            required
            checked={dpaAccepted}
            onChange={(e) => setDpaAccepted(e.currentTarget.checked)}
            label={
              <Text size="sm">
                {t('enterTrialGate.dpaPrefix')}{' '}
                <Anchor
                  href={import.meta.env.VITE_LANDING_PAGE_URL + '/dpa'}
                  target="_blank"
                  size="sm"
                >
                  {t('enterTrialGate.dpaLink')}
                </Anchor>
              </Text>
            }
          />
          <Checkbox
            required
            checked={subscriptionTermsAccepted}
            onChange={(e) => setSubscriptionTermsAccepted(e.currentTarget.checked)}
            label={
              <Text size="sm">
                {t('enterTrialGate.subscriptionTermsPrefix')}{' '}
                <Anchor
                  href={import.meta.env.VITE_LANDING_PAGE_URL + '/subscription-terms'}
                  target="_blank"
                  size="sm"
                >
                  {t('enterTrialGate.subscriptionTermsLink')}
                </Anchor>
              </Text>
            }
          />

          <Button type="submit" fullWidth loading={enterTrial.isPending}>
            {t('enterTrialGate.cta')}
          </Button>
        </Stack>
      </form>
    </Modal>
  );
}
